import { BaseDataResponse } from './../../base/entities/BaseEntities';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {BaseEntitiesResponse, BaseEntityResponse, BaseResponse, CompanyInfo, KeyValueEntity, SystemOptionEntity} from '@base/entities/BaseEntities';
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import { APIGatewayService } from "../gateway/APIGateway.service";


@Injectable()
export class SystemEndpoint extends BaseEndpoint  
{
    public constructor(api: APIGatewayService)
    {
        super("System", api);
    }
     

    //Get company info
    public GetCompanyInfo(): Observable<BaseEntityResponse<CompanyInfo>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, "CompanyInfo");
    }

    //Get the settings
    public GetSystemOptions(ModuleName: string | null = null): Observable<BaseEntitiesResponse<KeyValueEntity>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, "SystemOptions", { ModuleName: ModuleName });
    }
    public StoreMID(mid: string): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, "StoreMID", { MID: mid } );
    }

    //Keep session alive
    public KeepAlive(): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, "KeepAlive");
    }

    public GetEntitiesResources(): Observable<BaseDataResponse<[{ [entityName: string]: { [key: string]: any }}]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetEntitiesResources');
    }
}
